<template>
  <b-table
    :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
    :items="existingDocumentList"
    :fields="documentTableFields"
    :busy="loading"
    show-empty
    table-busy
  >
    <template #empty="">
      {{ $gettext('No documents found.') }}
    </template>
    <template #cell(actions)="data">
      <GekkoButton 
        @click="downloadDocument(data.item)"
        icon="fa-solid fa-download"
        variant="link" 
        class="text-info"
      />
      <GekkoButton
        v-if="deletable && !isCorrection"
        icon="fa-solid fa-trash-can"
        variant="link" 
        class="text-danger"
        @click="removeAttachedDocument({ type: objectType, fileId: data.item.id })"
      />
      <GekkoButton
        v-if="deletable && isCorrection"
        icon="fa-solid fa-trash-can"
        variant="link" 
        class="text-danger"
        v-gk-confirm="{
          title: $gettext('Delete file?'),
          message: $gettext('Are you sure you want to delete this document? This can\'t be undone.'),
          options: {
            variant: 'danger',
            confirmText: $gettext('Delete')
          },
          callback: deleteDocument,
          callbackParams: { type: objectType, fileId: data.item.id },
        }"
      />
    </template>
  </b-table>
</template>

<script>
import { mapActions } from "vuex";

import { promptDownload } from "@/utils/"

import DocumentService from "@/store/services/document.service";

import GekkoButton from "@/components/GekkoButton"

export default {
  name: "AttachedDocumentList",
  components: {
    GekkoButton
  },
  props: {
    objectId: {
      type: Number,
      default: null
    },
    objectType: {
      type: String,
      default: 'Correction'
    },
    deletable: {
      type: Boolean,
      default: false
    },
    documentList: {
      type: Array,
      default: null
    },
    publicDocuments: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      documentTableFields: [
        { key: 'title', label: '' },
        { key: 'actions', label: '', tdClass: 'text-right' }
      ],
      loading: false,
      fetchedDocuments: []
    }
  },
  computed: {
    existingDocumentList () {
      if (this.documentList) {
        return (this.documentList.length > 0) ? this.documentList : []
      } else {
        return this.fetchedDocuments
      }
    },
    isCorrection () {
      return this.objectType === 'Correction'
    },
    isQuotation () {
      return this.objectType === 'Quotation'
    }
  },
  created () {
    this.setupData()
  },
  methods: {
    ...mapActions({ 
      removeAttachedDocument: 'invoices/removeAttachedDocument',
      deleteDocument: 'invoices/deleteDocument',
    }),
    setupData () {
      if (!this.documentList && this.isCorrection) {
        this.loading = true
        DocumentService.getContentType({ type: 'Correction' }).then((response) => {
          DocumentService.list({ content_type: response.data, object_id: this.objectId }).then((response) => {
            this.fetchedDocuments = response.data.results
            this.loading = false
          })
        })
      }
    },
    downloadDocument (file) {
      if (this.publicDocuments) {
        location.href = window.Urls['public-documents-download'](file.uuid)
      } else {
        // location.href = window.Urls['document-download'](file.id)
        DocumentService.getDocumentBlob(file.id).then(response => {
          promptDownload(response)
        }).catch(error => console.error('Error downloading Document:', error));
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
